'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('order', {
        url: '/order',
        template: '<order></order>'
    });
}



// WEBPACK FOOTER //
// ./client/app/order/order.routes.js